import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { PaneHeader } from "@/components/settings/frame";
import { BookmarkletLink } from "@/components/shell/bookmarklet-link";

export const Route = createFileRoute("/settings/shops")({
  component: ShopsPage,
});

function ShopsPage() {
  const { t } = useTranslation("settings");
  return (
    <div>
      <PaneHeader title={t("nav.shops")} description={t("browser.description")} />
      <div className="border-t border-line-strong pt-6">
        <BookmarkletLink />
      </div>
    </div>
  );
}
